import { Dropdown } from "react-bootstrap";
import React from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";
import Button from "react-bootstrap/Button";

const StyledButton = styled(Button)`
  background-color: transparent;
  color: gray;
  padding: 3px;
  border: none;
  box-shadow: none;
  &:hover,
  &:focus,
  &:not(:disabled):not(.disabled):active {
    background-color: transparent;
    color: gray;
    border: none;
    box-shadow: none;
  }
`;

export const CustomToggle = React.forwardRef(
  ({ onClick, children, id }, ref) => {
    const handleClick = (e) => {
      e.preventDefault();
      onClick(e);
    };

    return (
      <StyledButton
        ref={ref}
        data-action="options"
        aria-haspopup="true"
        aria-expanded="false"
        onClick={handleClick}
        id={id}
      >
        {children}
      </StyledButton>
    );
  }
);

export const TableDropDownMenu = (props) => {
  let { children, placeInElement = document.body } = props;
  if (!placeInElement) {
    placeInElement = document.body;
  }
  return ReactDOM.createPortal(
    <Dropdown.Menu className="shadow-sm" flip>
      {children}
    </Dropdown.Menu>,
    placeInElement
  );
};

const TableDropDown = (props) => {
  const { children } = props;
  if (children && children.length > 0) {
    return (
      <Dropdown className="ellipsis-dropdown">
        <Dropdown.Toggle as={CustomToggle} customClass={"btn-opt"}>
          <i className="fas fa-ellipsis-h" />
        </Dropdown.Toggle>

        <TableDropDownMenu>{children}</TableDropDownMenu>
      </Dropdown>
    );
  }
  return "-";
};

export default TableDropDown;
